<template>
  <div class="">
    <b-card class="prodcard" v-if="showToken">
      <!-- <div class="img-container">
        <img
          :src="product.image"
          :alt="product.data"
          class="store-img"
          img-top
        />
      </div> -->
     
      <b-card-body class="body-details g-0">
        
        <b-card-text class="buy-btn">
         
         <b-button class="btn btn-block" @click="selectSymbol(name)">{{tokenName}}</b-button>
            
        </b-card-text>
      </b-card-body>
    </b-card>
    
  </div>
</template>

<script>


export default {
  props:["name"],
  data() {
    return {
      tokenName: '',
      showToken: true
    }
  },

  computed: {
   
  },
  created: function(){
   
  },

  methods: {
  selectSymbol(symbol){
          localStorage.setItem("symbol", symbol)
          this.$router.push({
              name: 'Address', params: {
                  symbol: symbol,
                  walletAddress: localStorage.getItem("walletAddress")
              }
          })
          
      },
      filteredTokens(){
        this.tokenName = this.name
        //console.log(this.tokenName)
        if(this.tokenName == 'BLOXDAO'){
            this.tokenName = 'BLOX';
           }
           if(
           this.tokenName == 'ABCDEE'
           || this.tokenName == 'TSTCAR'
                || this.tokenName == 'AUPNFT'
                || this.tokenName == 'AUTNFT'
                || this.tokenName == 'NFTLLP'
                || this.tokenName == 'TESTNF'
                || this.tokenName == 'TESTSS'
                || this.tokenName == 'TESTTT'
                || this.tokenName == 'Tstcar'
                || this.tokenName == 'TRTS'
                || this.tokenName == 'TRTSS'
                || this.tokenName == 'TSTCRLP'
                || this.tokenName == 'TSTCRLO'
                || this.tokenName == 'TSTCRP'
                || this.tokenName == 'TSTEWQ'
                || this.tokenName == 'TSTIOP'
                || this.tokenName == 'TSTIUO'
                || this.tokenName == 'TSTiuy'
                || this.tokenName == 'TSTMED'
                || this.tokenName == 'TSTPOI'
                || this.tokenName == 'TSTRCT'
                || this.tokenName == 'TSTRDF'
                || this.tokenName == 'TSTRDG'
                || this.tokenName == 'TSTRDP'
                || this.tokenName == 'TSTRPC'
                || this.tokenName == 'TSTRPG'
                || this.tokenName == 'TSTSTS'
                || this.tokenName == 'TSTTYU'
                || this.tokenName == 'TSTUIO'
                || this.tokenName == 'TSTUYR'
                || this.tokenName == 'TSTWEQ'
                || this.tokenName == 'TSTYTR'
                || this.tokenName == 'TSTYUI'
                || this.tokenName == 'WEDEWE'
                || this.tokenName == 'YXWVUT'
                || this.tokenName == 'NFT111'
                || this.tokenName == 'NFTNFT'
                || this.tokenName == 'TST321'
                || this.tokenName == 'TST342'
                || this.tokenName == 'TST345'
                || this.tokenName == 'TST423'
                || this.tokenName == 'TST654'
                || this.tokenName == 'TSTA05'
                || this.tokenName == 'TSTAZQ'
                || this.tokenName == 'TSTCCC'
                || this.tokenName == 'TSTDDD'
                || this.tokenName == 'TSTDEC'
                || this.tokenName == 'TSTF'
                || this.tokenName == 'TSTCCC'
                || this.tokenName == 'TSTGGG'
                || this.tokenName == 'TSTHHH'
                || this.tokenName == 'TSTKKK'
                || this.tokenName == 'TSTNFT'
                || this.tokenName == 'TSTRFV'
                || this.tokenName == 'TSTRP1'
                || this.tokenName == 'TSTTST'
                || this.tokenName == 'TSTVFR'
                || this.tokenName == 'TSTCDE'
                || this.tokenName == 'STSTST'
                || this.tokenName == 'TSTZAQ'
                || this.tokenName == 'NFTTST'
                || this.tokenName == 'TSTNTF'
                || this.tokenName == 'PISO'


                //prod
                || this.tokenName == 'TSTAZQ'
                || this.tokenName == 'TSTQAZ'
                || this.tokenName == 'TSTWSX'
                || this.tokenName == 'TSTXSW'
                || this.tokenName == 'TST1'
                || this.tokenName == 'TST2'
                || this.tokenName == 'TST3'
                || this.tokenName == 'TST4'
                || this.tokenName == 'TST5'
                || this.tokenName == 'TST6'
                || this.tokenName == 'TST7'
                || this.tokenName == 'TST8'
                || this.tokenName == 'TST9'
                || this.tokenName == 'TST10'
                || this.tokenName == 'TST11'
                || this.tokenName == 'TST12'
                || this.tokenName == 'TST13'
                || this.tokenName == 'TST14'
                || this.tokenName == 'TST15'
                || this.tokenName == 'TST16'
                || this.tokenName == 'TST17'
                || this.tokenName == 'TST18'
                || this.tokenName == 'TST19'
                || this.tokenName == 'TST20'
                || this.tokenName == 'TST21'
                || this.tokenName == 'TST22'
                || this.tokenName == 'TST23'
                || this.tokenName == 'TST24'
                || this.tokenName == 'TST25'
                || this.tokenName == 'TST26'
                || this.tokenName == 'TST27'
                || this.tokenName == 'TST28'
                || this.tokenName == 'TST29'
                || this.tokenName == 'TST30'
                || this.tokenName == 'TST31'
                || this.tokenName == 'TST32'
                || this.tokenName == 'TST33'
                || this.tokenName == 'TST34'
                || this.tokenName == 'TST35'
                || this.tokenName == 'TST36'
                || this.tokenName == 'TST37'
                || this.tokenName == 'TST38'
                || this.tokenName == 'TST39'
                || this.tokenName == 'TST40'
                || this.tokenName == 'TST41'
                || this.tokenName == 'TST42'
                || this.tokenName == 'TST43'
                || this.tokenName == 'TST44'
                || this.tokenName == 'TST45'
                || this.tokenName == 'TST46'
                || this.tokenName == 'TST47'
                || this.tokenName == 'TST48'
                || this.tokenName == 'TST49'
                || this.tokenName == 'TST50'
                || this.tokenName == 'TST51'
                || this.tokenName == 'TST52'
                || this.tokenName == 'TST53'
                || this.tokenName == 'TST54'
                || this.tokenName == 'TST55'
                || this.tokenName == 'TST56'
                || this.tokenName == 'TST57'
                || this.tokenName == 'TST58'
                || this.tokenName == 'TST59'
                || this.tokenName == 'TST60'
                || this.tokenName == 'TST61'
                || this.tokenName == 'TST62'
                || this.tokenName == 'TST63'
                || this.tokenName == 'TST64'
                || this.tokenName == 'TST65'
                || this.tokenName == 'TST66'
                || this.tokenName == 'TST67'
                || this.tokenName == 'TST68'
                || this.tokenName == 'TST69'
                || this.tokenName == 'TST70'
                || this.tokenName == 'TST71'
                || this.tokenName == 'TST72'
                || this.tokenName == 'TST73'
                || this.tokenName == 'TST74'
                || this.tokenName == 'TST75'
                || this.tokenName == 'TST76'
                || this.tokenName == 'TST77'
                || this.tokenName == 'TST78'
                || this.tokenName == 'TST79'
                || this.tokenName == 'TST80'
                || this.tokenName == 'TST81'
                || this.tokenName == 'TST82'
                || this.tokenName == 'TST83'
                || this.tokenName == 'TST84'
                || this.tokenName == 'TST85'
                || this.tokenName == 'TST86'
                || this.tokenName == 'TST87'
                || this.tokenName == 'TST88'
                || this.tokenName == 'TST89'
                || this.tokenName == 'TST90'
                || this.tokenName == 'TST91'
                || this.tokenName == 'TST92'
                || this.tokenName == 'TST93'
                || this.tokenName == 'TST94'
                || this.tokenName == 'TST95'
                || this.tokenName == 'TST96'
                || this.tokenName == 'TST97'
                || this.tokenName == 'TST98'
                || this.tokenName == 'TST99'
                || this.tokenName == 'TST100'
                || this.tokenName == 'ABCDEF'
                || this.tokenName == 'HASDSA'
                || this.tokenName == 'TESTT'
                || this.tokenName == 'TSTCAR'
                || this.tokenName == 'TSTCP'
                || this.tokenName == 'TSTERW'
                || this.tokenName == 'TSTGC'
                || this.tokenName == 'TSTGGC'
                || this.tokenName == 'TSTLLA'
                || this.tokenName == 'TSTLLP'
                || this.tokenName == 'TSTLLS'
                || this.tokenName == 'TSTQWE'
                || this.tokenName == 'TSTRCD'
                || this.tokenName == 'TSTRCP'
                || this.tokenName == 'TSTREN'
                || this.tokenName == 'TSTRFP'
                || this.tokenName == 'TSTRKP'
                || this.tokenName == 'TSTRPA'
                || this.tokenName == 'TSTRPP'
                || this.tokenName == 'ZYXWVU'
                || this.tokenName == 'TSTJAM'
                || this.tokenName == 'ASSET'
                || this.tokenName == 'YSDFSE'
                || this.tokenName == '00000'
                || this.tokenName == '123ASD'
                || this.tokenName == 'TKNTES'
                || this.tokenName == 'TKNTST'
                || this.tokenName == 'TST000'
                || this.tokenName == 'TST002'
                || this.tokenName == 'TST010'
                || this.tokenName == 'TST123'
                || this.tokenName == 'TST213'
                || this.tokenName == 'TST234'
                || this.tokenName == 'TST432'
                || this.tokenName == 'TST435'
                || this.tokenName == 'TST543'
                || this.tokenName == 'TST564'
                || this.tokenName == 'TSTA02'
                || this.tokenName == 'TSTA03'
                || this.tokenName == 'TSTA04'
                || this.tokenName == 'TSTA11'
                || this.tokenName == 'TSTAAA'
                || this.tokenName == 'TSTBBB'
                || this.tokenName == 'TSTBLX'
                || this.tokenName == 'TSTFFF'
                || this.tokenName == 'TSTEDC'
                || this.tokenName == 'TSTIII'
                || this.tokenName == '00000'
                || this.tokenName == '123ASD'
                || this.tokenName == 'TKNTES'
                || this.tokenName == 'TSTKKY'
                || this.tokenName == 'TSTJJJ'
                || this.tokenName == 'TSTQAZ'
                || this.tokenName == 'TSTSWX'
                || this.tokenName == 'TSTTGB'
                || this.tokenName == 'TSTTKN'
                || this.tokenName == 'TSTTOK'
                || this.tokenName == 'AUPXq'
                || this.tokenName == 'AUPXqs'
                || this.tokenName == 'DWGEWE'
                || this.tokenName == 'ERSFSF'
                || this.tokenName == 'ETESTT'
                || this.tokenName == 'P1SO'
                || this.tokenName == 'TEST1-bak'

                || this.tokenName == 'INRX'
                || this.tokenName == 'REW'
                || this.tokenName == 'REWRWE'
                || this.tokenName == 'RKP'
                || this.tokenName == 'SKY01'
                || this.tokenName == 't'
                || this.tokenName == 'TST011'

                || this.tokenName == 'TST111'
                || this.tokenName == 'tst15'
                || this.tokenName == 'TST546'
                || this.tokenName == 'TSt99'
                || this.tokenName == 'TSTCARL'
                || this.tokenName == 'TSTCRL'
                || this.tokenName == 'TSTCRLp'
                || this.tokenName == 'TSTcy'
                
                || this.tokenName == 'TSTEEE'
                || this.tokenName == 'TSTERT'
                || this.tokenName == 'TSTEWR'
                || this.tokenName == 'TSTKN'
                || this.tokenName == 'TSTLLFR'
                || this.tokenName == 'TSTLLFRt'
                || this.tokenName == 'tstrc'
                || this.tokenName == 'tstcarl'

                || this.tokenName == 'TSTRCL'
                || this.tokenName == 'TSTRDE'
                || this.tokenName == 'TSTRDH'
                || this.tokenName == 'TSTRDI'
                || this.tokenName == 'TSTREW'
                || this.tokenName == 'TSTRPB'
                || this.tokenName == 'TSTRPD'
                || this.tokenName == 'TSTRPF'

                || this.tokenName == 'TSTRPI'
                || this.tokenName == 'TSTRTY'
                || this.tokenName == 'TSTSLL'
                || this.tokenName == 'TSTSLP'
                || this.tokenName == 'TSTTRE'
                || this.tokenName == 'TSTWER'
                || this.tokenName == 'TTTTTT'

                || this.tokenName == 'TSTCPL'
                || this.tokenName == 'TST102'
                || this.tokenName == 'TST103'
                || this.tokenName == 'REWRWE'
                || this.tokenName == 'TST'
                || this.tokenName == 'ETH'
                || this.tokenName == 'TST104'
                || this.tokenName == 'TST105'

                || this.tokenName == 'TST106'
                || this.tokenName == 'TST107'
                || this.tokenName == 'TST108'
                || this.tokenName == 'TST109'
                || this.tokenName == 'TST110'
                || this.tokenName == 'TST111'
                || this.tokenName == 'TST112'
                || this.tokenName == 'TST113'
                
                || this.tokenName == 'TST114'
                || this.tokenName == 'TST115'
                || this.tokenName == 'TST116'
                || this.tokenName == 'TST117'
                || this.tokenName == 'TST118'
                || this.tokenName == 'TST119'
                || this.tokenName == 'TST120'
                || this.tokenName == 'TST121'
                || this.tokenName ==  'TST'
                || this.tokenName ==  'TST101'
                || this.tokenName ==  'TSTCPL'
                || this.tokenName ==  'TST102'
                || this.tokenName ==  'TST103'
                || this.tokenName ==  'TST104'
                || this.tokenName ==  'TST105'
                || this.tokenName ==  'TST106'
                || this.tokenName ==  'TST107'
                || this.tokenName ==  'TST108'
                || this.tokenName ==  'TST109'
                || this.tokenName ==  'TST110'
                || this.tokenName ==  'TST111'
                || this.tokenName ==  'TST112'
                || this.tokenName ==  'TST113'
                || this.tokenName ==  'TST114'
                || this.tokenName ==  'TST115'
                || this.tokenName ==  'TST116'
                || this.tokenName ==  'TST117'
                || this.tokenName ==  'TST999'
                || this.tokenName ==  'TST998'
                || this.tokenName ==  'TST120'
                || this.tokenName ==  'TS2BLX'
                || this.tokenName ==  'TS3BLX'
                || this.tokenName ==  'TEST1'
                || this.tokenName ==  'TEST2'
                || this.tokenName ==  'TEST3'
                || this.tokenName ==  'TEST4'
                || this.tokenName ==  'TEST5'
                || this.tokenName ==  'TEST6'
                || this.tokenName ==  'TEST7'
                || this.tokenName ==  'TEST8'
                || this.tokenName ==  'TEST9'
                || this.tokenName ==  'TEST10'
                || this.tokenName ==  'TEST11'
                || this.tokenName ==  'TEST12'
                || this.tokenName ==  'TEST13'
                || this.tokenName ==  'TEST14'
                || this.tokenName ==  'TEST15'
                || this.tokenName ==  'TEST16'
                || this.tokenName ==  'TEST17'
                || this.tokenName ==  'TEST18'
                || this.tokenName ==  'TEST19'
                || this.tokenName ==  'TEST20'
                || this.tokenName ==  'TEST21'
                || this.tokenName ==  'TEST22'
                || this.tokenName ==  'TEST23'
                || this.tokenName ==  'TEST24'
                || this.tokenName ==  'TEST25'
                || this.tokenName ==  'TEST26'
                || this.tokenName ==  'TEST27'
                || this.tokenName ==  'TEST28'
                || this.tokenName ==  'TEST29'
                || this.tokenName ==  'TEST30'
                || this.tokenName ==  'TEST31'
                || this.tokenName ==  'TEST32'
                || this.tokenName ==  'TEST33'
                || this.tokenName ==  'TEST34'
                || this.tokenName ==  'TEST35'
                || this.tokenName ==  'TEST36'
                || this.tokenName ==  'TEST37'
                || this.tokenName ==  'TEST38'
                || this.tokenName ==  'TEST39'
                || this.tokenName ==  'TEST40'
                || this.tokenName ==  'TEST41'
                || this.tokenName ==  'TEST42'
                || this.tokenName ==  'TEST43'
                || this.tokenName ==  'TEST44'
                || this.tokenName ==  'TEST45'
                || this.tokenName ==  'TEST46'
                || this.tokenName ==  'TEST47'
                || this.tokenName ==  'TEST48'
                || this.tokenName ==  'TEST49'
                || this.tokenName ==  'TEST50'
                || this.tokenName ==  'TEST51'
                || this.tokenName ==  'TEST52'
                || this.tokenName ==  'TEST90'                

                


                //prod
                || this.tokenName == 'CARL'
                || this.tokenName == 'CARLOO'
                || this.tokenName == 'TSTZAQ'
                || this.tokenName == 'TSTAQZ'
                || this.tokenName == 'RCLP'){
                  this.showToken = false
                  //console.log('test')
                }
      }

  },
  mounted:function(){
    this.filteredTokens();
  }


};
</script>

<style scoped>

.prodcard {
  margin: 0.5em;
  width: 11rem;
  height: auto;
  border-radius: 6px;
  background-image: linear-gradient(
    180deg,
    rgba(249, 250, 253, 1) 29%,
    rgba(235, 238, 249, 1) 59%,
    rgba(214, 220, 244, 1) 88%
  );
  cursor: pointer;
  margin-bottom: 15px;
}
.card-body {
  margin: 0 auto !important;
  align-items: center;
}

.img-container {
  padding: 10px 0px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  margin: 0 auto;
}
.store-img {
  width: 5rem;
  margin: auto auto;
  transition: all 1s ease-in-out;
}
.img-container:hover .store-img {
  transform: scale(1.2);
}
.body-details{
  left: 0 !important;
  right: 0 !important;
  display: block;
  justify-content: center !important;
  margin: 0 auto!important;
}
.buy-btn{
  margin: 0 auto;
  display: flex;
  justify-content: center;
}
/* .store-item-icon {
  position: absolute;
} */
</style>
